
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'

import { Header as CommonHeader } from 'vue-common'

import type { Breadcrumb } from '../types/breadcrumb'

export default defineComponent({
  name: 'Header',
  components: {
    CommonHeader
  },
  data: () => ({
    client_url: process.env.VUE_APP_CLIENT_URI ?? 'http://localhost:4200'
  }),
  methods: {
    navigateToBreadcrumb(breadcrumb: Breadcrumb): void {
      this.$router.push(`${breadcrumb.to}`)
    }
  },
  computed: {
    ...mapGetters({
      folder: 'sharedFolders/sharedFolder',
      techpack: 'techpack/getTechpack'
    }),
    breadcrumbs(): Array<Breadcrumb> {
      if (!this.$route?.meta?.breadcrumbs) {
        return []
      }
      return this.$route?.meta?.breadcrumbs.map((breadcrumb: Breadcrumb) => {
        const { text } = breadcrumb
        switch (text) {
          case 'Shared Folders':
          case ':name':
            return {
              text: breadcrumb.text.replace(':name', this.folder?.name ? this.folder?.name : ''),
              to: breadcrumb.to.replace(':id', this.folder?._id ? this.folder?._id : '')
            }
          case ':techpackName':
            return {
              text: breadcrumb.text.replace(':techpackName', this.techpack?.name ? this.techpack?.name : ''),
              to: breadcrumb.to.replace(':techpackId', this.techpack?._id ? this.techpack?._id : '')
            }
          default:
            return {
              text: '',
              to: ''
            }
        }
      })
    }
  }
})
